import { useCallback } from "react";

import useLazyRestQuery from "@/remoteState/useLazyRestQuery";
import { AGATHA_ORIGIN } from "@/search/search.constants";
import stringifyParams from "@/utils/stringifyParams";

interface InitialProps {
  skip: boolean;
  classroomGradeLevels?: [];
}

export interface UseLazyStandardsFetchProps {
  [parameter: string]: string;
}

export const useLazyStandardsFetch = ({
  skip = false,
  classroomGradeLevels = [],
}: InitialProps) => {
  const createResource = useCallback(
    (queryParams?: UseLazyStandardsFetchProps) => {
      if (skip) return undefined;

      const params = {
        ...queryParams,
        ...(classroomGradeLevels
          ? { classroom_grade_levels: classroomGradeLevels }
          : {}),
      };

      const resource = `${AGATHA_ORIGIN}/api/v2/standard-display-fields/`;
      const queryString =
        stringifyParams(params as UseLazyStandardsFetchProps) || "";
      return `${resource}${queryString}`;
    },
    [],
  );

  // @ts-expect-error when returning undefined in order to skip api call.
  return useLazyRestQuery(createResource);
};
